var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_layouts"},[_c('mHeader'),_c('router-view',{staticClass:"base_layouts_content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }